const AssetType = {
    MULTIMEDIA: 'multimedia',
    SCREEN: 'screen',
    STICKER: 'sticker',
    PROMOTION: 'promotion',
    DOWNLOAD: 'download',
    SHOWME: 'show-me',
    SURVEY: 'survey',
    QUIZ: 'quiz',
    PRODUCT: 'product',
    DISCOUNT: 'discount',
    GIFT: 'gift',
    CALL_TO_ACTION: 'call-to-action',
    INTERACTIVE_APP: 'interactive-app'
}

export default AssetType;